import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
    createNmiTemplate,
    CreateNmiTemplateRequest,
    UpdateNmiTemplateRequest,
    updateNmiTemplate,
} from '../endpoints/nmiTemplates';

export const useCreateNmiTemplateMutation = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (request: CreateNmiTemplateRequest) => createNmiTemplate(request),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['nmi-templates'] });
        },
    });
};

export const useUpdateNmiTemplateMutation = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, request }: { id: string; request: UpdateNmiTemplateRequest }) =>
            updateNmiTemplate(id, request),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['nmi-templates'] });
        },
    });
};
